import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import Box from '../box/box.jsx';
import styles from './blocks.css';

class BlocksComponent extends React.Component {
    // 这里把原来的 pure component 改为普通 component 否则想传递额外的props会报错，要不就适配它原来的逻辑。
    // const {
    //     containerRef,
    //     dragOver,
    //     ...componentProps
    // } = props;

    constructor (props) {
        super(props);
    }

    render () {
        return (
            <Box
                className={classNames(styles.blocks, {
                    [styles.dragOver]: this.props.dragOver
                })}
                {...this.props.componentProps}
                componentRef={this.props.containerRef}
            />
        );
    }

};
BlocksComponent.propTypes = {
    containerRef: PropTypes.func,
    dragOver: PropTypes.bool
};
export default BlocksComponent;
